import {getPageData, standardPropertyItem, getStatus, dataLayerPush} from '../../lib/tracking';
import _isEmpty from 'lodash/isEmpty';

export const trackLiveability = (eventName, property, category) => {
  let pd = getPageData();

  let liveability_event = {
    event: eventName,
    page_type: pd.type,
    page_name: pd.name,
  };

  const doLiveabilityData = () => {
    let fields = ['postcode', 'suburb', 'state', 'item_id', 'address', 'property_type', 'property_status', 'liveability_score'];
    fields.map((fieldName) => liveability_event[fieldName] = 'not available');
    if (property.address) {
      if (property.address.postCode) liveability_event.postcode = property.address.postCode;
      if (property.address.suburb) liveability_event.suburb = property.address.suburb;
      if (property.address.stateCode) liveability_event.state = property.address.stateCode;
    }
    let spi = standardPropertyItem(property);
    if (spi && !_isEmpty(spi)) {
      liveability_event.item_id = spi.item_id;
      liveability_event.address = spi.item_name;
    }
    if (property.type) liveability_event.property_type = property.type;
    if (property.category) liveability_event.property_status = property.recentlySold ? 'Recently Sold' : getStatus([property.category]);
    if (property.liveability && property.liveability.livebilityIndex) liveability_event.liveability_score = property.liveability.livebilityIndex;
  }

  doLiveabilityData();

  if (eventName == 'liveability_tooltip_click' && category) liveability_event.liveability_category = category;
  if (eventName == 'liveability_impression_similar') {
    liveability_event.page_type = 'carousel';
    liveability_event.page_name = 'carousel';
    liveability_event.event = 'liveability_search_impression';
  }
  dataLayerPush(liveability_event);
}
